const parseCustomization = (customization) => {
  if (!customization) {
    return null;
  }

  if (typeof customization === "string") {
    try {
      return JSON.parse(customization);
    } catch (error) {
      return null;
    }
  }

  return customization;
};

export const getRushSessionPopupMinutes = (login) => {
  const customization = parseCustomization(login?.Customization);
  const rawValue = customization?.rushSessionPopup ?? customization?.RushSessionPopup;

  if (rawValue == null || rawValue === false || rawValue === "") {
    return null;
  }

  const minutes = Number(rawValue);

  if (!Number.isFinite(minutes) || minutes <= 0) {
    return null;
  }

  return minutes;
};
